import { useLocation } from 'react-router';

import { NAME_SUFFIX_BUDGET, truncateToServerLimit } from '@/util/checkNames';
import { generateUniqueName } from '@/util/strings';
import { LENGTH_XS } from '@/util/validation/constants';

export const NEW_ROLE_ID = 'new';

export type NewRoleState = { roleName?: string; sourceRoleId?: string };

const NO_STATE: NewRoleState = {};

export const newRolePath = (slug: string) => `/${slug}/account/manage/roles/${NEW_ROLE_ID}`;

export const useNewRoleState = (roleId?: string): NewRoleState => {
  const location = useLocation();
  return roleId === NEW_ROLE_ID ? ((location.state as NewRoleState) ?? NO_STATE) : NO_STATE;
};

export const copyRoleName = (sourceName: string, existingNames: string[]): string => {
  const base = truncateToServerLimit(sourceName, LENGTH_XS - NAME_SUFFIX_BUDGET);
  return generateUniqueName(base, [...existingNames, base], { hasExtension: false });
};
